module.exports = __webpack_public_path__ + "static/media/Project-korea.601070dc.svg";